import React, { Component } from 'react';
import { connect }          from 'react-redux';
import AnalyticsManager from '../../app/analytics';
import { convertToSortedArray, getMediaPath } from 'app/functions';

import './footer.scss';

//components
import NewsletterForm from '../shared/footerNewslatterForm/footerNewsletterForm';
import DynamicLink from  '../../components/dynamic_link/index';

//assets
import social_fb from 'assets/icons/social-fb.png';
import social_insta from 'assets/icons/social-insta.png';
import social_fb_colored from 'assets/icons/social_fb_colored.png';
import social_insta_colored from 'assets/icons/social_insta_colored.png';
import app_download from 'assets/icons/app-download-white.svg';
import drop_green from 'assets/icons/drop_white.svg';
import app_store from  'assets/icons/app-store.svg';
import google_play from  'assets/icons/google-play.svg';
import app_store_hover from  'assets/icons/app-store-hover.svg';
import google_play_hover from  'assets/icons/google-play-hover.svg';
import { addPopup } from "../../redux/actions";

class Footer extends Component {

    constructor(props){
        super(props);

        this.state = {
            linksToShow:6,
            showMore:true,
        };

        this.getAllLinks = this.getAllLinks.bind(this);
        this.moreBtnOnClick = this.moreBtnOnClick.bind(this);
        this.handleDownloadAppClick = this.handleDownloadAppClick.bind(this);
    }

    componentDidMount(){
        const data = ['אודות', 'אפליקציה', 'הטבות', 'בתי עסק', 'הצטרפות למועדון', 'צור קשר', 'רישום לניוזלטר', 'הצטרפות ספקים', 'שירות לקוחות', 'שינוי כתובת', 'הנחות- שינויים ועדכונים'];
        data.length > this.state.linksToShow ? this.setState({showMore:true}) : this.setState({showMore:false});
    }

    shouldComponentUpdate(nextProps, nextState) {
        let update = (nextProps.deviceState !== this.props.deviceState) || (nextState !== this.state);
        return update;
    }

    handleInmanageOnCick(){
        window.open('https://www.inmanage.co.il/', '_blank','noopener norefferer');
    }

    handleDownloadAppClick(){
        window.open(this.props.appStoreLink, '_blank','noopener norefferer');
    }


    getAllLinks() {
        const data = convertToSortedArray(this.props.footerLinks.links);
        let res = [];

        // custom Exception
        let BreakException = {};

        let index = 0;
        // custom break statement
        try {
            for(let key in data) {

                // break statement
                if (index >= this.state.linksToShow && this.props.deviceState === 'mobile') throw BreakException;

                const handleLinkClick = () => AnalyticsManager.logFooterItemPress(data[key].title);

                res.push(
                    <div key={key} className='link'>
                        <DynamicLink to='/' key={index} data={data[key].link} onClick={handleLinkClick}>
                            {data[key].title}
                        </DynamicLink>
                    </div>
                );
                index++;
            }
        }
        catch (e) {
            if (e !== BreakException) throw e;
        }

        return res;
    }

    moreBtnOnClick(){
        const data = convertToSortedArray(this.props.footerLinks.links);
        this.setState({linksToShow:data.length, showMore:false});
    }

    handleIconOnClick(title){
        AnalyticsManager.logFooterItemPress(title);

        const socialMedia = this.props.footerLinks.social_media_links;
        const appStores = this.props.footerLinks.app_store_links;

        for (let key in socialMedia){
            if (socialMedia[key].title === title) {
                AnalyticsManager.logSocialMediaLinkPress(title);
                window.open(socialMedia[key].link.route, '_blank', 'noopener');
            }
        }

        for (let key in appStores){
            if (appStores[key].title === title) {
                AnalyticsManager.logAppStoreLinkPress(title);
                window.open(appStores[key].link.route, '_blank', 'noopener');
            }
        }
    }

    render() {
        const isMobile = this.props.deviceState === 'mobile';
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        return (

            <footer>
                    <div className="mail-container">
                        <div className='desktop-wrap'>
                            <NewsletterForm show_img={isMobile} className={'footer-mewslatter'} />
                            {isLaptopOrDesktop &&
                            <div className='mobile-stores'>
                                <div className='store-wrapper' onClick={()=>this.handleIconOnClick('Google Play')}>
                                    <img className='store-img' src={getMediaPath(google_play)} alt=''/>
                                    {isLaptopOrDesktop &&
                                    <img className='store-img colored' src={getMediaPath(google_play_hover)} alt=''/>}
                                </div>
                                <div className='store-wrapper' onClick={()=>this.handleIconOnClick('App Store')}>
                                    <img className='store-img' src={getMediaPath(app_store)} alt=''/>
                                    {isLaptopOrDesktop &&
                                    <img className='store-img colored' src={getMediaPath(app_store_hover)} alt=''/>}
                                </div>
                            </div>
                            }
                        </div>
                        <div className='social-media-container'>
                            <span className='label'>עקבו אחרינו</span>
                            <div className='social-media-wrapper'>
                                <div className='icon-wrapper' onClick={()=>this.handleIconOnClick('Facebook')}>
                                    <img className='social-logo' src={social_fb} alt=''/>
                                    {isLaptopOrDesktop &&
                                    <img className='social-logo colored' src={getMediaPath(social_fb_colored)} alt=''/>}
                                </div>
                                <div className='icon-wrapper' onClick={()=>this.handleIconOnClick('Instagram')}>
                                    <img className='social-logo' src={getMediaPath(social_insta)} alt=''/>
                                    {isLaptopOrDesktop &&
                                    <img className='social-logo colored' src={getMediaPath(social_insta_colored)} alt=''/>}
                                </div>
                            </div>
                        </div>
                        <button className='app-download-wrapper'
                                onClick={this.handleDownloadAppClick}
                                aria-label="הורד אפליקציה">
                            <img className='app-download-img' src={getMediaPath(app_download)} alt=''/>
                            <span className='app-download-span'>להורדת האפליקציה</span>
                        </button>
                    </div>
                    <div className='links-container'>
                        {this.getAllLinks()}
                    </div>
                    {this.state.showMore && isMobile &&
                    <div className='more-links' onClick={this.moreBtnOnClick}>
                        <span className='more-span'>הצג עוד</span>
                        <img className='more-img' src={getMediaPath(drop_green)} alt='' />
                    </div>
                    }
                    <div className='bottom-banner'>
                        <span className='rights-span'>{this.props.text.footer_rights}</span>
                        <span className="rights-span inmanage">
                        <span className='rights-span immanage' onClick={this.handleInmanageOnCick}>created by Inmanage</span>
                        <span className="rights-span inmanage version">v{process.env.REACT_APP_VERSION}</span>
                        </span>
                    </div>
            </footer>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        footerLinks: store.config.FooterLinks,
        appStoreLink: store.config.AppStoreLink,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPopup: (payload) =>dispatch(addPopup(payload)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Footer);
